export default function PortfolioHero() {
  return (
    <section className="relative pt-32 lg:pt-40 pb-20 lg:pb-32 bg-black overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-bold text-white mb-6 lg:mb-8 leading-none">
            Unsere
            <br />
            Projekte
          </h1>
          <p className="text-base lg:text-lg xl:text-xl text-white/60 max-w-2xl leading-relaxed mx-auto">
            Eine Auswahl unserer erfolgreich umgesetzten Projekte. 
            Jede Website ist einzigartig und perfekt auf die Bedürfnisse unserer Kunden zugeschnitten.
          </p>
        </div>
      </div>

      {/* Decorative element */}
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-[#d1bc8a]/5 rounded-full blur-3xl -translate-y-1/2"></div>
    </section>
  );
}